import { createFileRoute } from '@tanstack/react-router'

import { CaseStudyLayout } from '../components/CaseStudyLayout'
import { fairyHomes } from '../caseStudies/fairyHomes'
import { caseStudyHead } from '../caseStudySeo'

export const Route = createFileRoute('/FairyHomes')({
  head: () => caseStudyHead(fairyHomes.content),
  component: FairyHomesPage,
})

function FairyHomesPage() {
  return <CaseStudyLayout content={fairyHomes.content} />
}
